import {
  ACT_INSTANCES_FETCH_CONTEXTS_INIT_ACTION,
  ACT_INSTANCES_FETCH_CONTEXTS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_CONTEXT_INIT_ACTION,
  ACT_INSTANCES_GET_CONTEXT_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_CONTEXT_INIT_ACTION,
  ACT_INSTANCES_ADD_CONTEXT_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_CONTEXT_INIT_ACTION,
  ACT_INSTANCES_DELETE_CONTEXT_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_CONTEXT_FILTERS,
  ACT_INSTANCES_SET_SELECTED_CONTEXT,
} from '../../constants/actions';

const defaultState = {
  contexts: [],
  singleContext: undefined,
  didLoadContexts: false,
  isLoadingContexts: false,
  isLoadingSingleContext: false,
  isAddingContext: false,
  isDeletingContext: false,
  isContextDeleted: false,
  selectedContext: undefined,
  filters: {
    dynasties: [],
    cities: [],
    tags: [],
    types: [],
  },
};

const contextsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_INSTANCES_FETCH_CONTEXTS_INIT_ACTION:
      return {
        ...state,
        contexts: [],
        isLoadingContexts: true,
        didLoadContexts: false,
      };
    case ACT_INSTANCES_FETCH_CONTEXTS_SUCCESS_ACTION:
      return {
        ...state,
        contexts: action.payload,
        isLoadingContexts: false,
        didLoadContexts: true,
      };
    case ACT_INSTANCES_ADD_CONTEXT_INIT_ACTION:
      return {
        ...state,
        isAddingContext: true,
      };
    case ACT_INSTANCES_ADD_CONTEXT_SUCCESS_ACTION: {
      const newContextsList = state.contexts.push(action.payload);
      return {
        ...state,
        isAddingContext: false,
        Contexts: newContextsList,
      };
    }
    case ACT_INSTANCES_GET_CONTEXT_INIT_ACTION:
      return {
        ...state,
        singleContext: undefined,
        isLoadingContexts: true,
      };
    case ACT_INSTANCES_GET_CONTEXT_SUCCESS_ACTION:
      return {
        ...state,
        singleContext: action.payload,
        isLoadingSingleContext: false,
      };
    case ACT_INSTANCES_DELETE_CONTEXT_INIT_ACTION:
      return {
        ...state,
        isDeletingContext: true,
        isContextDeleted: false,
      };
    case ACT_INSTANCES_DELETE_CONTEXT_SUCCESS_ACTION:
      return {
        ...state,
        isDeletingContext: false,
        isContextDeleted: true,
      };
    case ACT_INSTANCES_UPDATE_CONTEXT_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case ACT_INSTANCES_SET_SELECTED_CONTEXT:
      return {
        ...state,
        selectedContext: action.payload,
      };
    default:
      return state;
  }
};

export default contextsReducer;
